export default __webpack_public_path__ + "static/media/books-1024w.5e1b0e7c.avif";